import type React from "react";
import { ReactComponent as Svg } from "./assets/exotic-logo.svg";
import * as styles from "./Icon.module.scss";

type ExoticProps = React.SVGProps<SVGSVGElement>;

export const Exotic = ({ className, ...props }: ExoticProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
